import { render, staticRenderFns } from "./BIM.vue?vue&type=template&id=1055f3b0"
import script from "./BIM.vue?vue&type=script&lang=js"
export * from "./BIM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports